"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.categorySelected = void 0;
const constants_1 = require("../constants");
exports.categorySelected = ({ category, session, }) => {
    const props = {
        [constants_1.EventProperty.SELECTED_CATEGORY]: category,
        [constants_1.EventProperty.USER_ID]: session.userID,
        [constants_1.EventProperty.CUSTOMER_NAME]: session.customer,
        [constants_1.EventProperty.SESSION_ID]: session.sessionID
    };
    window.analytics.track(constants_1.EventName.CATEGORY_SELECTED, props);
};
